import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    background: {
      default: "#fff",
      paper: "#fff"
    },
    common: {
      black: "#ffffff",
      white: "#ffffff"
    },
    primary: {
      contrastText: "#ffffff",
      dark: "#FF690A",
      light: "#212121",
      main: "#095AA5",
    },
    secondary: {
      contrastText: "#ffffff",
      dark: "#FF690A",
      light: "#ff7c7c",
      main: "#FF0000"

    },

    text: {
      primary: "#464646",
      secondary: "#095AA5"
    }
  }
});

export default theme;
